import moment from "moment"
import SkyAlertAPI from "../controllers/SkyAlertAPI"

export const formatUriImage = (idImage, defaultPathImage = "") => {
  let uriBg = defaultPathImage
  if (idImage) {
    uriBg = SkyAlertAPI.getPicURL(idImage, "image")
  }
  return uriBg
}

export const toHttps = (url = "") =>
  typeof url === "string" ? url.replace(/^http:\/\//i, "https://") : url

export const getIframeURL = (url) => {
  if (!url) {
    return ""
  }
  // Force https on the embedded track URL to avoid iOS ATS (NSURLError -1022) blocks.
  const secureUrl = toHttps(url)
  const soundCloudUrl = `"https://w.soundcloud.com/player/?url=${secureUrl}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"`
  return `<iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src=${soundCloudUrl}></iframe>`
}

export const formatArticlePublishAt = (date = "") => {
  const datePublishAt = moment(date);
  if (!datePublishAt.isValid()) {
    return '';
  }

  return `Publicado ${datePublishAt.format("LL")}`
}



// WEBPACK FOOTER //
// ./src/helpers/index.js